GameView = require "views/base/game"
Prefix = require("lib/prefix")
{ DraggyView }  = require("views/components/draggy")

class PieChartView extends GameView
  template: require("./template")

  events:
    "iostap .btn-done": "submit"

  show: ->
    super
    @setEl @findOne(".pie"), "pie"
    @setEl @findOne(".pie-ring-input"), "knob-input"
    @setEl @findOne(".pie-ring-value"), "knob-value"
    @setEl @findOne(".pie-ring-answer"), "knob-answer"

    @resetDashOffset(@getEl("knob-input"))
    @resetDashOffset(@getEl("knob-answer"))

    @createDraggy()

    @enterGame()

  createDraggy: ->
    @draggy = new DraggyView
      el: @getEl("pie")
      radius: @getEl("pie").offsetWidth / 2
      isParent: true

    @listenTo @draggy, "drag", @onDrag
    @listenTo @draggy, "drop", @onDrop

  onDrag: (draggy, isInitialDrag) ->
    @currentValue = @roundValue(draggy)
    @labelEl @getEl("knob-value"), @currentValue

    @transition @getEl("knob-input"),
      if isInitialDrag then "all 300ms" else "none"

    @offsetStrokeDash(@getEl("knob-input"), draggy.t)

  onDrop: (draggy, isReset) ->
    if not isReset
      draggy.reset({t: @roundPos(draggy)})
    else
      @transition(@getEl("knob-input"), "all 300ms")
      @offsetStrokeDash(@getEl("knob-input"), draggy.t)

      if @currentValue?
        @setState("touched")

  resetDashOffset: (path) ->
    c = 10 * Math.PI
    path.style.strokeDashoffset = c
    path.style.strokeDasharray  = [c, c].join(" ")

    @circumference = c

  offsetStrokeDash: (path, t) ->
    if @options.config().direction is "rtl"
      t = Math.PI * 2 - t

    percent = -(t - Math.PI * 2) / (Math.PI * 2)
    offset  = @circumference * percent

    path.style.strokeDashoffset = "#{offset}px"

  roundValue: (draggy) ->
    {min, max, increment} = @options.data.pie
    value = Big(max - min)
      .mul(@roundPercent(draggy))
      .div(increment)
      .round()
      .mul(increment)
      .plus(min)

    if @options.config().direction is "rtl" then Big(max - value) else value

  roundPos: (draggy) ->
    (Math.PI * 2) * @roundPercent(draggy)

  roundPercent: (draggy) ->
    {increment, min, max} = @options.data.pie

    max     = Big(max).sub(min).div(increment).round().mul(increment).plus(min)
    percent = _.limit(draggy.t / (Math.PI * 2), 0, 1)
    steps   = Big(max).sub(min).div(increment).valueOf()

    Big(steps)
      .mul(percent)
      .round()
      .div(steps)

  labelEl: (el, value) ->
    {prefix, suffix} = @options.data.pie
    el.innerHTML = "#{prefix}#{value}#{suffix}"

  showAnswer: ->
    @offsetStrokeDash @getEl("knob-answer"), @draggy.t
    @animateAnswerKnob(@getEl("knob-answer"))

  isCorrect: ->
    @currentValue? and
    @currentValue?.eq @options.data.answer.value

  animateAnswerKnob: (el) ->
    {answer, pie} = @options.data
    {increment, min, max} = pie
    max     = Big(max).sub(min).div(increment).round().mul(increment).plus(min)
    percent = (answer.value - min) / (max - min)
    percent = 1 - percent if @options.config().direction is "rtl"

    el.offsetWidth

    @transition(el, "all 600ms")
    @offsetStrokeDash(el, percent * Math.PI * 2)

  endGame: ->
    super

    @submit()

  answerDetails: ->
    questions    = @options.metadata?.questions or []

    return [] unless questions.length > 0

    question         = questions[0]
    correct          = @isCorrect()
    value            = parseInt(@currentValue)

    answer           = _.find question.answers, (a) -> a.correct is correct
    details          = question: question.question, answer: answer

    details.answer.content = value
    [ details ]

module.exports = PieChartView
